import CabinDescription from './cabin-description';
import FAQSection from './faq-section';
import HouseRules from './house-rules';

export default function OverviewTab() {
  return (
    <div id="overview-tab" className="flex flex-col gap-10 md:gap-16 items-center">
        <CabinDescription />

        <div className="w-full border-t-2 border-green-800 my-6"></div>

        <HouseRules />

        <div className="w-full border-t-2 border-green-800 my-6"></div>

        <FAQSection />
    </div>

  )
}
